import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
        flex-direction: row;
    }
`;

const Media = styled.div`
    flex: 1.4;
`;

const Image = styled.div`
    position: relative;
    padding-bottom: 56%;
    img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }
`;

const Video = styled.div`
    position: relative;
    padding-bottom: 56%;
    img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }
`;

const Play = styled.a`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    background-color: rgba(255, 255, 255, 0.5);
    cursor: pointer;

    svg {
        font-size: 19px;
        color: ${props => props.theme.palette.primary.normal};
    }
`;

const VideoContainer = styled.iframe`
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

const Content = styled.div`
    flex: 1;
    padding: 16px;

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
        padding: 36px;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
        padding: 58px;
    }
`;

const Title = styled.h1`
    font-family: Anton;
    font-size: 44px;
    font-weight: 400;
    line-height: 95%;
    text-transform: uppercase;
    margin: 0;

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
        font-size: 50px;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.md}){
        font-size: 68px;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
        font-size: 86px;
    }
`;

const Description = styled.div`
    margin: 20px 0;
    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
        font-size: 18px;
    }
`;


export { Container, Media, Image, Video, Play, VideoContainer, Content, Title, Description };